module.exports = __webpack_public_path__ + "static/img/1.debdf49.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/eng/1.png
// module id = z9I5
// module chunks = 0